import React from 'react';
import PropTypes from 'prop-types';
import { compose, wrapDisplayName } from 'recompose';

import { withFetch, withLoading } from 'modules/with-fetch';
import queryString from 'query-string';

import {
  isExistingOnboardingEntry,
  hasLegacyOnboardingData,
} from 'modules/functions/src/hasExistingOnboardingData';
import CompleteWaiver from './CompleteWaiver';
import Onboarding from './Onboarding';

class OnboardingWrapper extends React.Component {
  state = {
    checkingWaiver: false,
  };

  // We need to check every 15 seconds to see if the waiver has been completed
  componentDidMount() {
    if (!this.hasCompletedWaiver()) {
      this.waiverCheckInterval = setInterval(() => {
        this.waiverCheck();
      }, 10000);
      this.hideChecking = setInterval(() => {
        this.setState({
          checkingWaiver: false,
        });
      }, 20000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.waiverCheckInterval);
    clearInterval(this.hideChecking);
  }

  waiverCheck = () => {
    // console.devLog.info('Checking to see if the waiver is completed now...');
    this.setState(
      {
        checkingWaiver: true,
      },
      () => this.props.myWaiver.refreshData(false),
    );
  };

  hasCompletedWaiver = () =>
    this.props.myWaiver &&
    this.props.myWaiver.data.length > 0 &&
    this.props.myWaiver.data[0].completed;

  render() {
    // If the waiver isn't completed, we need the person to do that
    const clientHasExistingOnboardingEntry = isExistingOnboardingEntry(
      this.props.myQuestionnaire,
    );
    const clientHasLegacyOnboardingData = hasLegacyOnboardingData(
      this.props.myQuestionnaire,
    );
    let localHideSidebar = this.state.isHiddenSidebar;
    // Hide the sidebar if the client doesn't have any onboarding information
    if (!clientHasExistingOnboardingEntry && !clientHasLegacyOnboardingData) {
      // console.devLog.info('Uhhh, ');
      localHideSidebar = true;
    }

    const { bypassWaiver } = queryString.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });

    if (
      !clientHasLegacyOnboardingData &&
      !this.hasCompletedWaiver() &&
      !bypassWaiver
    ) {
      // console.devLog.info('User needs to complete waiver');
      return (
        <CompleteWaiver
          myWaiver={this.props.myWaiver}
          {...this.props}
          waiverCheck={this.waiverCheck}
          checkingWaiver={this.state.checkingWaiver}
          myQuestionnaire={this.props.myQuestionnaire}
        />
      );
    }
    return (
      <div className="d-flex p-0 page__complete-waiver">
        <Onboarding
          myQuestionnaire={this.props.myQuestionnaire}
          {...this.props}
          isHiddenSidebar={localHideSidebar}
        />
      </div>
    );
  }
}

OnboardingWrapper.propTypes = {
  myQuestionnaire: PropTypes.object.isRequired,
  myWaiver: PropTypes.object.isRequired,
  myClient: PropTypes.object.isRequired,
};

const EnhancedComponent = compose(
  withFetch('Client/MyQuestionnaire', undefined, 'myQuestionnaire'),
  withFetch('Client/MyClient', undefined, 'myClient'),
  withFetch('Client/MyTrainer', undefined, 'myTrainer'),
  withFetch('Client/MyWaiver', undefined, 'myWaiver'),
  withLoading('myQuestionnaire'),
  withLoading('myClient'),
  withLoading('myTrainer'),
  withLoading('myWaiver', undefined, undefined, {
    position: 'absolute',
    left: '50%',
    top: '20px',
  }),
)(OnboardingWrapper);

EnhancedComponent.displayName = wrapDisplayName(OnboardingWrapper, 'withFetch');

export default EnhancedComponent;
